module.exports = __webpack_public_path__ + "static/media/ev-catalog-screenshot.cc9ba121.png";